import React, { memo, useEffect } from 'react';

import { Button, Col, Row, Switch } from 'antd';

import { Field, useFormikContext } from 'formik';
import { SelectFormField } from 'v2/components/Shared/FormFields/SelectFormField';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';
import type { IAffiliate } from 'v2/interfaces/affiliate';

import type { IFormCommision } from '../interfaces';

interface IProps {
  handleClose: (...args: any[]) => any;
  affiliate: IAffiliate;
}

const FormCommision = ({ handleClose, affiliate }: IProps) => {
  const { values, setFieldValue, isSubmitting, isValid } = useFormikContext<IFormCommision>();

  const onChangeActive = (checked: boolean) => {
    setFieldValue('active', checked);
  };

  const onChangeType = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue('type', e.target.value);
    setFieldValue('value', '');
  };

  const typeOptions = [
    { label: 'Porcentagem', value: 'P' },
    { label: 'Valor', value: 'V' }
  ];

  useEffect(() => {
    if (affiliate.custom_commission_type && affiliate.custom_commission) {
      setFieldValue('active', true);
    }

    if (affiliate.custom_commission_type) {
      setFieldValue('type', affiliate.custom_commission_type);
    }

    if (affiliate.custom_commission) {
      setFieldValue('value', affiliate.custom_commission);
    }
  }, [affiliate, setFieldValue]);

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col sm={24}>
          <div className='flex items-center gap-2'>
            <Switch checked={values.active} disabled={isSubmitting} onChange={onChangeActive} />
            <span>Habilitar comissão diferenciada</span>
          </div>
        </Col>

        <Col xs={24} md={14}>
          <Field
            id='type'
            name='type'
            label='Tipo da comissão'
            fullWidth
            disabled={true}
            options={typeOptions}
            component={SelectFormField}
            onChange={onChangeType}
          />
        </Col>

        <Col xs={24} md={10}>
          {values.type === 'P' && (
            <Field
              id='value'
              disabled={!values.active}
              name='value'
              label='Porcentagem'
              mask='percent'
              fullWidth
              component={TextFormField}
            />
          )}

          {values.type === 'V' && (
            <Field
              id='value'
              disabled={!values.active}
              name='value'
              mask='money'
              label='Valor'
              fullWidth
              component={TextFormField}
            />
          )}
        </Col>
      </Row>

      <div className='m-4' />

      <div className='flex justify-end gap-2'>
        <Button disabled={isSubmitting} onClick={() => handleClose()}>
          Fechar
        </Button>

        <Button type='primary' disabled={isSubmitting || !isValid} htmlType='submit'>
          Salvar
        </Button>
      </div>
    </>
  );
};

export default memo(FormCommision);
